
import { defineComponent } from "vue";
import LotterySignForm from "./Form.vue";

export default defineComponent({
  components: {
    LotterySignForm,
  },
  setup() {
    return {};
  },
});
